module.exports = "<div class=\"col-12 text-center\">\n  <iw-loader [isLoading]=\"loading\" message=\"Cargando historial...\"></iw-loader>\n</div>\n<div *ngIf=\"!loading\">\n  <ng2-smart-table [settings]=\"settings\" [source]=\"source\">\n  </ng2-smart-table>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/history-task-users/history-task-users.component.html
// module id = ./src/app/shared/history-task-users/history-task-users.component.html
// module chunks = main